import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import RoutesPath from '../../constants/routes-path';

import { showToast, startLoading, stopLoading } from '../../services/common-service'

import settings from '../../config';

import Header from './components/Header';
import api from '../../factory/api';
import { getApplicationDataAsync } from '../../services/application-service';
import { getLoggedUserAsync } from '../../services/user-service';
import CardInstance from '../../components/cards/CardInstance';
import { generateAuthorizationToken } from '../../services/utils';
import CardConnect from '../../components/cards/CardConnect';
import CardApresentation from '../../components/cards/CardApresentation';
import Copyright from '../../components/Copyright';
import CardToken from '../../components/CardToken';
import BlipPortalToastTypes from '../../constants/blip-portal-toast-types';
import ErrorLoad from '../../components/ErrorLoad';
import CommandsList from '../../components/CommandsList';
import Start from '../../components/Start';
import Pipelines from '../../components/Pipelines';
import CustomTab from '../../CustomTab';
import CodeEditor from '../../components/CodeEditor';
import ResourcesList from '../../components/ResourcesList';
import Resource from '../../components/Resource';


import { IframeMessageProxy } from 'iframe-message-proxy'
import IMPContainer from '../../constants/iframe-message-proxy-container';

const PAGE_ICON = 'plugin';
const BLANK = '_blank';

const Home = () => {
    const history = useHistory();
    const { t, i18n } = useTranslation();

    const [appInfo, setAppInfo] = useState({});
    const [user, setUser] = useState({});
    const [language, setLanguage] = useState('');

    const [isLoading, setIsLoading] = useState(true)

    const [error, setError] = useState(null)

    const [customTab, setCustomTab] = useState(null)

    const [resourceOpened, setResourceOpened] = useState(null)

    // const { data } = useFetch(`/instances`);

    useEffect(() => {
        // if (appInfo != {} && user != {})
        if (appInfo?.tenantId && user?.culture) { }
    }, [appInfo, user])

    useEffect(() => {
        getAppDataAsync()
    }, [])

    const getAppDataAsync = async () => {
        const app = await getApplicationDataAsync();
        setAppInfo(app);

        console.log("appInfo", app);

        const loggedUser = await getLoggedUserAsync();
        setUser(loggedUser);
        console.log("loggedUser", loggedUser)

        setLanguage(i18n.language);
    };

    const getResource = async (key, parameter) => {
        try {
            const result = await IframeMessageProxy.sendMessage({
                action: IMPContainer.Actions.SEND_COMMAND,
                content: {
                    command: {
                        method: IMPContainer.CommandMethods.GET,
                        uri: `/resources/${key}`
                    },
                    // destination: IMPContainer.Destinations.BLIP_SERVICE
                }
            });

            return result.response
        } catch (error) {
            console.error(error)
            if (typeof error == "string") {
                error = JSON.parse(error)
                if (error?.message && typeof error.message == "string")
                    error.message = JSON.parse(error.message)
            }

            console.error("errorrrr", error)

            if (error?.code == 67 || error?.message?.reason?.code == 67)
                return parameter ? { [parameter]: [] } : {}

            throw error
        }
    }

    return (
        <div className="flex" style={{ height: "100vh", overflowX: "auto" }}>
            <div className="ph1 ph4-m ph5-ns pb5 relative" style={{ flex: 1 }}>
                <Header
                    title={t('title.homePage')}
                    icon={PAGE_ICON}
                    onClick={() => window.open("https://docs.sharkdev.com.br/blip/gerenciador_de_recursos", BLANK)}
                />

                {resourceOpened ?
                    <Resource
                        resource={resourceOpened}
                        setResourceOpened={setResourceOpened}
                        getResource={getResource}
                    />
                    :
                    <ResourcesList
                        setResourceOpened={setResourceOpened}
                        getResource={getResource}
                    />
                }

                <Copyright />
            </div>

            <CustomTab
                opened={customTab != null}
                setCustomTab={setCustomTab}
                {...customTab}
            />
        </div>
    );
};

Home.propTypes = {};

export default Home;
